<template>
  <div>
    <h1 class="c-heading-1">We zijn benieuwd naar je feedback</h1>
    <answer-scale question="In welke mate zou je deze FutureForward-scan aanraden aan collega-ondernemers?" :amount="10" label-left="Onwaarschijnlijk" label-right="Waarschijnlijk" v-model="aanraden"/>
    <answer-scale question="In welke mate voldeed de scan aan je verwachtingen?" :amount="10" label-left="Onwaarschijnlijk" label-right="Waarschijnlijk" v-model="verwachtingen"/>
    <answer-scale question="Ga je naar aanleiding van deze scan een volgende stap zetten als ondernemer?" :amount="10" label-left="Onwaarschijnlijk" label-right="Waarschijnlijk" v-model="volgendestap"/>
    <input-group label="Heb je nog vragen, opmerkingen of ideeën om deze scan te vervolledigen met nieuwe trends of voorbeelden? We verwelkomen ze graag.">
      <textarea :id="uniqueId" v-model="remarks" slot-scope="{ uniqueId }"></textarea>
    </input-group>
    <p><input type="checkbox" v-model="opDeHoogte"> Hou me op de hoogte van nieuwe trends binnen mijn sector.</p>
    <div class="c-toolbar">
      <div class="c-toolbar__right">
        <navigation-button to="finished" @click="submitFeedback">Feedback verzenden</navigation-button>
      </div>
    </div>
    <div class="c-footer">
      <p>
        <img class="c-logo-footer" src="../assets/images/logo2.png" alt="Unizo" width="266">
      </p>
      <p>The Future Forward scan is een initiatief van UNIZO in samenwerking met het Agentschap Innoveren en Ondernemen.</p>
      <p><strong>#sterkondernemen</strong>. Meer starters, meer blijvers en meer groeiers: daar gaan we voor! Agentschap Innoveren & Ondernemen en haar partners willen u daarbij ondersteunen. Dit project is slechts één van de vele initiatieven waar u gebruik van kan maken. Ontdek ze allemaal op <a href="http://www.sterkondernemen.be/">www.sterkondernemen.be</a>.</p>
    </div>
  </div>
</template>

<script>
import AlertBox from '../components/AlertBox.vue'
import AnswerScale from '../components/AnswerScale.vue'
import InputGroup from '../components/InputGroup.vue'
import NavigationButton from '../components/NavigationButton.vue'
export default {
  components: {
    AlertBox,
    AnswerScale,
    InputGroup,
    NavigationButton
  },
  data () {
    return {
      aanraden: null,
      verwachtingen: null,
      volgendestap: null,
      remarks: '',
      opDeHoogte: false
    }
  },
  methods: {
    submitFeedback () {
      this.$store.commit('updateFeedback', {
        aanraden: this.aanraden,
        verwachtingen: this.verwachtingen,
        volgendestap: this.volgendestap,
        remarks: this.remarks,
        opDeHoogte: this.opDeHoogte
      })
      this.$store.commit('updateProgress', 'FEEDBACK_SENT')
      this.$store.dispatch('updateDatabaseRecord')
      this.$store.commit('setInitialState')
    }
  }
}
</script>
